import Vue from 'vue'
import { microservice } from 'src/app-config'

// const url = (api) => microservice.domain + ':8120/common' + api
const url = (api) => microservice.domain + '/common' + api

export const getDatatableUserPreferences = ({ userSid, dataTableCode, token }) => {
  return new Promise((resolve, reject) => {
    Vue.http.get(url('/dataTablePreferences'), {
      headers: {
        'Authorization': 'Bearer ' + token
      },
      params: {
        userSid,
        dataTableCode
      }
    }).then(response => {
      if (response.body.userPreferenceJSON) {
        console.log(response.body.userPreferenceJSON)
        // resolve(JSON.parse(response.body.userPreferenceJSON))
        resolve(response.body.userPreferenceJSON)
      } else {
        reject({ message: 'No user preference found for data table.' })
      }
    }).catch(response => {
      reject({ message: 'Exception occurred when request user preference for data table.' })
    })
  })
}

export const updateDatatableUserPreferences = ({ userSid, dataTableCode, userPreferenceJSON, token }) => {
  return new Promise((resolve, reject) => {
    Vue.http.put(url('/dataTablePreferences'), {
      userSid,
      dataTableCode,
      // userPreferenceJSON: JSON.stringify(userPreferenceJSON)
      userPreferenceJSON
    }, {
      headers: {
        'Authorization': 'Bearer ' + token
      }
    }).then(response => {
      resolve()
    }).catch(response => {
      reject({ message: 'Failed to update data table preferences.' })
    })
  })
}

export const getClientUserInactiveTimeout = (token) => {
  return new Promise((resolve, reject) => {
    let headers = {'content-type': 'application/json', Authorization: 'Bearer ' + token}
    Vue.http.get(url('/clientUserInactiveTimeout'), {
      headers
    }).then(response => {
      resolve(response.body)
    }).catch(response => {
      reject({ message: 'Failed to get client user inactive timeout.' })
    })
  })
}



// WEBPACK FOOTER //
// ./src/services/common.js